import _ from "lodash";
import {ADDITIONS_EDUCATION_DISABLE, hasTag} from "@/helper/characteristic/Tag";

export function itemsValid (
	{
		selected,
		items,
		withExperience,
		supplementsConfig,
		withSelfAssessment,
		withEducation,
		withRequirement
	}
)
{
	if (selected === undefined)
	{
		return false;
	}

	let relevantSelectedItems;

	if (items)
	{
		const itemIds = _.map(items, 'id');

		relevantSelectedItems = _.filter(selected, item => _.includes(itemIds, item.item.id));
	}
	else
	{
		relevantSelectedItems = selected;
	}

	if (withExperience && !experienceValid(relevantSelectedItems))
	{
		return false;
	}

	if (withSelfAssessment && !selfAssessmentValid(relevantSelectedItems))
	{
		return false;
	}

	if (withEducation && !educationsValid(relevantSelectedItems))
	{
		return false;
	}

	if (withRequirement && !requirementValid(relevantSelectedItems))
	{
		return false;
	}

	return supplementsValid(relevantSelectedItems, supplementsConfig);
}

function experienceValid (relevantSelectedItems)
{
	const itemsWithoutChild = getItemsWithoutChild(relevantSelectedItems);

	const itemsWithoutChildAndExperience = _.filter(
		relevantSelectedItems,
		item => item.item.children.length === 0 && item.experience !== undefined
	);

	return itemsWithoutChild.length === itemsWithoutChildAndExperience.length;
}

function getItemsWithoutChild (items)
{
	return _.filter(items, item => item.item.children.length === 0);
}

function selfAssessmentValid (relevantSelectedItems)
{
	return itemsValidByProperty(relevantSelectedItems, 'selfAssessment');
}

function educationsValid (relevantSelectedItems)
{
	return itemsValidByProperty(relevantSelectedItems, 'educationsFinished', ADDITIONS_EDUCATION_DISABLE)
		&& itemsValidByProperty(relevantSelectedItems, 'educationsUnfinished', ADDITIONS_EDUCATION_DISABLE);
}

function requirementValid (relevantSelectedItems)
{
	return itemsValidByProperty(relevantSelectedItems, 'requirement');
}

function itemsValidByProperty (relevantSelectedItems, property, disablingTag)
{
	const invalidItems = _.filter(
		relevantSelectedItems,
		item =>
		{
			if (disablingTag && hasTag(item.item, disablingTag))
			{
				return false;
			}

			if (item.item.children.length > 0)
			{
				return false;
			}

			return item[property] === undefined;
		}
	);

	return invalidItems.length === 0;
}

function supplementsValid (relevantSelectedItems, supplementsConfig)
{
	if (supplementsConfig?.disable === true)
	{
		return true;
	}

	const nothingAllowed = supplementsConfig?.nothingAllowed !== false;

	let valid = true;

	const itemsWithoutChild = getItemsWithoutChild(relevantSelectedItems);

	_.forEach(itemsWithoutChild, selectedItem =>
	{
		const itemCharacteristicTypes = _.filter(
			selectedItem.item.itemCharacteristicTypes,
			item =>
			{
				if (!supplementsConfig?.types)
				{
					return true;
				}

				return _.includes(supplementsConfig.types, item.type.id);
			}
		);

		if (!itemCharacteristicTypes || itemCharacteristicTypes.length === 0)
		{
			return true; // continue
		}

		if (!selectedItem.supplements)
		{
			valid = false;

			return false; // break
		}

		const validSupplements = _.filter(selectedItem.supplements, supplement =>
		{
			if (!nothingAllowed)
			{
				return supplement.items.length > 0;
			}

			return true;
		});

		if (validSupplements.length !== itemCharacteristicTypes.length)
		{
			valid = false;

			return false; // break
		}
	});

	return valid;
}
